import { motion } from "framer-motion";
import ScrollAnimation from "../components/animations/ScrollAnimation";
import { useTranslation } from 'react-i18next';
import { useSectionT } from "../contexts/PageVariantContext";

const Development = () => {
    const { t } = useTranslation();
    const sectionT = useSectionT();
    const developmentAreas = t(sectionT('development.areas'), { returnObjects: true }) as Array<{
        title: string;
        description: string;
        stacks: Array<{
            name: string;
            description: string;
        }>;
    }>;

    return (
        <section className="py-20 bg-gray-50">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <ScrollAnimation>
                    <div className="text-center mb-16">
                        <h2 className="text-3xl md:text-4xl font-poppins font-bold text-primary-900 mb-4">
                            {t(sectionT('development.title'))}
                        </h2>
                        <div className="w-20 h-1 bg-accent-500 mx-auto mb-6"></div>
                        <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                            {t(sectionT('development.subtitle'))}
                        </p>
                    </div>
                </ScrollAnimation>

                <div className="grid md:grid-cols-3 gap-8">
                    {developmentAreas.map((area, index) => (
                        <ScrollAnimation key={index} delay={index * 0.15}>
                            <motion.div
                                className="bg-white rounded-xl overflow-hidden shadow-md p-8"
                                whileHover={{ y: -10 }}
                                transition={{ duration: 0.3 }}
                            >
                                <h3 className="text-xl font-semibold text-primary-900 mb-4">
                                    {area.title}
                                </h3>
                                <p className="text-gray-600 mb-6">{area.description}</p>
                                <div className="space-y-4">
                                    {area.stacks.map((stack, stackIndex) => (
                                        <div key={stackIndex} className="flex items-start">
                                            <div className="flex-shrink-0">
                                                <div className="w-2 h-2 rounded-full bg-accent-500 mt-2"></div>
                                            </div>
                                            <div className="ml-3">
                                                <p className="font-medium text-primary-900">{stack.name}</p>
                                                <p className="text-sm text-gray-600">{stack.description}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </motion.div>
                        </ScrollAnimation>
                    ))}
                </div>

                <div className="text-center mt-16">
                    <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                        {t(sectionT('development.description'))}
                    </p>
                </div>
            </div>
        </section>
    );
};

export default Development; 